import mutations from './doctorUtilization.mutations'
import actions from './doctorUtilization.actions'
import getters from './doctorUtilization.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
